import React, { Component } from "react";
import "./BillingPage.scss";

interface BillingPageProps {}

interface BillingPageState {}

class BillingPage extends Component<BillingPageProps, BillingPageState> {
  constructor(props: BillingPageProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="billing-page">
        <h1 className="billing-page-title">Billing</h1>
        <p className="billing-page-lead">
          Manage subscription and invoices here (placeholder). No payment provider is wired yet.
        </p>

        <div className="billing-page-summary">
          <div className="billing-page-row">
            <span className="billing-page-label">Current plan</span>
            <span className="billing-page-value">Pro (dummy)</span>
          </div>
          <div className="billing-page-row">
            <span className="billing-page-label">Next invoice</span>
            <span className="billing-page-value">$29.00 on Apr 19, 2026 (sample)</span>
          </div>
          <div className="billing-page-row">
            <span className="billing-page-label">Payment method</span>
            <span className="billing-page-value">Visa •••• 4242 (sample)</span>
          </div>
        </div>
      </div>
    );
  }
}

export default BillingPage;
